import React from "react";
import styled from "styled-components";

const StyledButton = styled.button`
  padding: 10px 20px;
  background-color: #FF372F;;
  color: white;
  border: none;
  cursor: pointer;
  margin-top: 20px;
  border-radius: 3px;
  font-size: 16px;
  &:hover {
    background-color: darkred;
  }
`;

const Button: React.FC<{ title: string; onClick: () => void }> = ({ title, onClick }) => {
  return <StyledButton onClick={onClick}>{title}</StyledButton>;
};

export default Button;
